import {ACTION} from './constants';
let initialState={
    kycVerificationData: {
        apiLoaded: false,
    },
    savePreLoginResponse: {
        apiLoaded: false,
    },
    otpVerificationDataEcart: {
        apiLoaded: false,
    },
    forceLogout: {
        apiLoaded: false,
    },
};
export default function AuthenticationReducer(state=initialState, action) {

    switch (action.type) {
        case ACTION.VERIFY_PAN :
            return {...state, panVerification:{...action.data, apiLoaded: true}};
        
        case ACTION.VERIFY_ECART_KYC :
            return {...state, kycVerificationData:{...action.data, apiLoaded: true}};
        
        case ACTION.VERIFY_ECART_OTP :
            return {...state, otpVerificationDataEcart:{...action.data, apiLoaded: true}};
        
        case ACTION.RESEND_OTP :
            return {...state, otpResendData:{...action.data, apiLoaded: true}};

        // case ACTION.SAVE_PRE_LOGIN_DATA:
        //     return {...state, savePreLoginResponse:{...action.data, apiLoaded: true}}


        case ACTION.FORCE_LOGOUT:
            return {...state, forceLogout:{...action.data, apiLoaded: true}};

        case ACTION.CLEAN_AUTH_CONTENT:
            return {...state, kycVerificationData:{ apiLoaded: false }};

        default:
            return state;
    }
}